(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-amazon-price"] && !Shopify.designMode) return;
  try {
    function expireAmazonPrices(){document.querySelectorAll('[data-price-expires]').forEach(el=>{if(Date.now()/1000>=Number(el.dataset.priceExpires))el.remove();});}
expireAmazonPrices();setInterval(expireAmazonPrices,60000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-image-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-image-viewer')) {
  customElements.define('dd-image-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.links = Array.from(this.closest('article').querySelectorAll('[data-dd-image]'));
      this.image = this.querySelector('[data-viewer-image]');
      this.previous = this.querySelector('[data-viewer-prev]');
      this.next = this.querySelector('[data-viewer-next]');
      this.links.forEach((link, index) => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = link;
        this.showImage(index);
        this.dialog.showModal();
        document.documentElement.classList.add('dd-viewer-open');
      }, options));
      this.querySelector('[data-viewer-close]').addEventListener('click', () => this.dialog.close(), options);
      this.previous.addEventListener('click', () => this.showImage(this.index - 1), options);
      this.next.addEventListener('click', () => this.showImage(this.index + 1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showImage(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('dd-viewer-open');
        this.opener?.focus({ preventScroll: true });
      }, options);
    }
    showImage(index) {
      this.index = Math.max(0, Math.min(index, this.links.length - 1));
      const link = this.links[this.index];
      const description = link.querySelector('img')?.alt || link.getAttribute('aria-label') || '';
      this.image.src = link.href;
      this.image.alt = description;
      this.querySelector('[data-viewer-caption]').textContent = description;
      this.querySelector('[data-viewer-count]').textContent = `${this.index + 1} / ${this.links.length}`;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.links.length - 1;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) document.documentElement.classList.remove('dd-viewer-open');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-startseite"] && !Shopify.designMode) return;
  try {
    function initDackeldingeHomepage(scope) {
  const roots = scope.matches?.('[data-dd-start]') ? [scope] : scope.querySelectorAll('[data-dd-start]');
  roots.forEach(root => {
    if(root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const filters = root.querySelector('.dds-filters');
    const cards = [...root.querySelectorAll('[data-dds-group]')];
    const result = root.querySelector('[data-dds-result]');
    if(!filters || !cards.length) return;
    filters.hidden = false;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-dds-filter]');
      if(!button) return;
      const selected = button.dataset.ddsFilter;
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      cards.forEach(card => { card.hidden = selected !== 'all' && card.dataset.ddsGroup !== selected; });
      const count = cards.filter(card => !card.hidden).length;
      result.textContent = result.dataset.label.replace('[count]',String(count));
    });
  });
}
initDackeldingeHomepage(document);
document.addEventListener('shopify:section:load', event => initDackeldingeHomepage(event.target));
  } catch(e) { console.error(e); }
})();

})();
